import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

import EmptyRowsMessage from '../../common-components/EmptyRowsMessage';

import * as stationsReducer from '../../stations-mgmt/reducer';

import * as stationsAction from '../action-mgr';

import * as strings from '../../helpers/strings';

const styles = {
  root: {
    padding: 10,
    background: "#eee"
  },
  chip: {
    marginRight: 5
  }
}

class SelectedStationsChips extends Component {
  constructor() {
    super();

    this.handleRemoveStation = this.handleRemoveStation.bind(this);
  }

  handleRemoveStation = index => e => {
    this.props.removeStationFromSelections(index);
  }

  render() {
    const { stations, classes } = this.props;

    return (
      <div className={classes.root}>
        {(!stations) ? <EmptyRowsMessage message={strings.msgNoStationIsSelected} /> : (!stations.length) ? <EmptyRowsMessage message={strings.msgNoStationIsSelected} /> : false}

        {
          (stations) ?
            stations.map((station, index) =>
              <Chip
                key={station.id}
                label={station.name}
                onDelete={this.handleRemoveStation(index)}
                color={strings.colorPrimary}
                className={classes.chip}
                style={{ marginBottom: '5px' }}
              />
            )
            : false
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stations: stationsReducer.getSelectedStations(state)
});

const mapActionsToProps = {
  removeStationFromSelections: stationsAction.removeStationFromSelections
}

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(SelectedStationsChips)
);